import type { BatchPreviewTableColumn } from "../batch-preview-table";
import type { ProjectLite } from "@/entities/project";

import { useTranslation } from "react-i18next";

import { useGetProjects } from "@/entities/projects";
import ProjectBreadcrumb from "@/modules/project/project-breadcrumb";
import { TABLE_FILTER_TEXT } from "@/modules/table-filter";

import {
  useBatchPreviewTableColumnName,
  useBatchPreviewTableColumnState,
} from "../batch-preview-table";
import { BATCH_PREVIEW_PAGE_SIZE } from "../batch-preview.constant";
import { useBatchPreviewIdsParam } from "../batch-preview.hook";

import {
  filterProjectByLocationsName,
  sortProjectByLocationsName,
} from "./batch-preview-project-assign-page.helper";

export const useBatchPreviewProjectAssignPage = () => {
  const { t } = useTranslation();
  const { idsParam, ids } = useBatchPreviewIdsParam();

  const { projects, isLoading } = useGetProjects({
    enabled: ids.length > 0,
    params: {
      "filter[id]": idsParam,
      "page[size]": BATCH_PREVIEW_PAGE_SIZE,
    },
  });

  const columns: BatchPreviewTableColumn<ProjectLite>[] = [
    useBatchPreviewTableColumnName("project"),
    {
      key: "location",
      dataIndex: "ancestors",
      title: t("global:location"),
      render: (_ancestors, project) => (
        <ProjectBreadcrumb
          project={project}
          include={["location"]}
          hideIcon
          ellipsis
          compact
        />
      ),
      ...TABLE_FILTER_TEXT,
      onFilter: (value, project) =>
        filterProjectByLocationsName(project, value as string),
      sorter: (a, b) => sortProjectByLocationsName(a, b),
    },
    useBatchPreviewTableColumnState("project", projects),
  ];

  return {
    projects,
    loading: isLoading,
    columns,
  };
};
